import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth';
import { HubConnectionBuilder, HubConnection } from '@microsoft/signalr';
import { AvisosService } from 'src/app/layout/components/avisos/services/avisos.service';
import { NotificacionesService } from 'src/app/layout/components/notificaciones/services/notificaciones.service';
import { environment } from 'src/environments/environment';
import { SubscripcionService } from './subscripcion.service';
import { Conexion } from './types/conexiones';
import { Eventos } from './types/eventos';

@Injectable({
  providedIn: 'root'
})

export class SignalRService {

  private HubConnection: HubConnection;

  constructor(
    private router: Router,
    private avisosService: AvisosService,
    private notificacionesService: NotificacionesService,
    private subscripcionService: SubscripcionService,
    private authService: AuthService,
  ) { }

  public InicializadorServidor() {
    const hubConnectionBuilder = new HubConnectionBuilder();
    const CodOrganizacion = localStorage.getItem('CodOrganizacion');

    this.HubConnection = hubConnectionBuilder.withUrl(environment.API_SIGNALR).withAutomaticReconnect(this.Intentos()).build();

    this.HubConnection.on(Conexion.MetodoBackOffice, (mensaje) => {
      this.ValidarEvento(mensaje);
    });

    this.HubConnection.start().then(() => {
      this.HubConnection.invoke(Conexion.AddBackOffice);
      this.HubConnection.invoke(Conexion.AddBackOfficeORG, CodOrganizacion);
    });

    this.HubConnection.onreconnected(() => {
      this.FinalizarServidor();
      this.InicializadorServidor();
      this.ComprobarPerdidasInfo();
    });
  }

  public FinalizarServidor() {
    this.HubConnection.stop();
  }

  private ValidarEvento(evento) {
    if (evento.Tipo === Eventos.Aviso) {
      this.avisosService.CrearAviso(evento);
      return;
    }

    if (evento.Tipo === Eventos.Notificaciones) {
      this.notificacionesService.CrearNotificacion(evento);
      return;
    }

    if (evento.Tipo === Eventos.CierreSesion) {
      this.notificacionesService.CrearNotificacion(evento);
      setTimeout(() => {
        this.authService.signOut();
        this.router.navigateByUrl('/sign-in');
      }, evento.Tiempo);
      return;
    }

    if (evento.Tipo === Eventos.VerificarSubscripcion) {
      this.avisosService.CrearAviso(evento);
      this.subscripcionService.VerificarSubscripcion();
      return;
    }

    if (evento.Tipo === Eventos.ComprobacionGeneral) {
      this.ComprobarPerdidasInfo();
      return;
    }

    // if(evento.Tipo === Eventos.Permisos){
    //   this.permissionsService.getInfoUsuario();
    // }
  }

  private ComprobarPerdidasInfo(){
    this.avisosService.CargarAvisos();
    this.subscripcionService.VerificarSubscripcion();
  }

  private Intentos() {
    let intentos = [];
    for (let index = 0; index < 60; index++) {
      intentos = [...intentos, 5000 * index];
    }
    return intentos;
  }

}
